import React from "react";
import { BsArrowRight } from "react-icons/bs";

interface BlogSectionType {
    posts?: any;
    ArabicText?: string;
    noHead?: boolean;
    ArabicButton?: string;
}

const BLOG_CARDS = [
    {
        id: "whatsapp-tools",
        title: "Top 15 WhatsApp tools every business needs in 2025",
        tag: "WhatsApp automation",
        readTime: "7 mins approx",
        imageUrl: "https://cdn.prod.website-files.com/66efa862351a8bef3b48cb70/67b466e311f46c3e3f7f408e_whatsapp-tools.png",
        href: "https://gallabox.com/blog/whatsapp-tools",
    },
    {
        id: "whatsapp-automation-tools",
        title: "20 WhatsApp Automation Tools to Scale your Growth",
        tag: "WhatsApp automation",
        readTime: "7 mins approx",
        imageUrl: "https://cdn.prod.website-files.com/66efa862351a8bef3b48cb70/67b469d0aedb239b07d6fc23_whatsApp-%20automation-tools.png",
        href: "https://gallabox.com/blog/whatsapp-automation-tools",
    },
    {
        id: "whatsapp-marketing",
        title: "How to use WhatsApp marketing to grow your brand",
        tag: "WhatsApp marketing",
        readTime: "7 mins approx",
        imageUrl: "https://cdn.prod.website-files.com/66efa862351a8bef3b48cb70/683b16dd758ebc7ce28c486a_Blog_%20Whatsapp%20Marketing.webp",
        href: "https://gallabox.com/blog/whatsapp-marketing",
    },
];

const BlogSection: React.FC<BlogSectionType> = ({ noHead, ArabicText, ArabicButton }) => {
    return (
        <section className="bg-gray-50">
            <div className="max-w-7xl mx-auto py-16 px-6">
                <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-10">
                    {!noHead && (
                        <h2 className="text-6xl" style={{ fontFamily: "Degular Display" }}>
                            {ArabicText || "More from Gallabox"}
                        </h2>
                    )}
                    <a href="/blog" className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:no-underline">
                        {ArabicButton ?? "VIEW MORE"}
                        <BsArrowRight className="text-base" />
                    </a>
                </div>

                <div className="grid gap-8 lg:grid-cols-3">
                    {BLOG_CARDS.map((post) => {
                        return (
                            <a
                                key={post.id}
                                href={post.href}
                                target="_blank"
                                rel="noreferrer"
                                className="group flex h-full flex-col overflow-hidden border border-gray-200 bg-white transition-shadow duration-300 hover:no-underline hover:shadow-lg"
                            >
                                <div className="w-full overflow-hidden bg-gray-100">
                                    <img src={post.imageUrl} alt={post.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
                                </div>
                                <div className="flex flex-col gap-4 px-6 py-6">
                                    <div className="flex items-center gap-3 text-xs text-gray-500">
                                        <span
                                            className="rounded-full  px-3 py-1 text-xs font-medium text-black"
                                            style={{ backgroundColor: "rgba(239, 242, 255, 1)", border: "1px solid rgba(187, 202, 255, 1)" }}
                                        >
                                            {post.tag}
                                        </span>
                                        <span>{post.readTime}</span>
                                    </div>
                                    <p className="m-0 text-xl font-medium text-gray-900 line-clamp-3">{post.title}</p>
                                    <div className="mt-auto flex justify-end text-blue-600 transition-transform duration-300 group-hover:translate-x-1">
                                        <BsArrowRight className="text-xl" />
                                    </div>
                                </div>
                            </a>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default BlogSection;
